import { render, staticRenderFns } from "./Throw.vue?vue&type=template&id=8318c23c&scoped=true"
import script from "./Throw.vue?vue&type=script&lang=js"
export * from "./Throw.vue?vue&type=script&lang=js"
import style0 from "./Throw.vue?vue&type=style&index=0&id=8318c23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8318c23c",
  null
  
)

export default component.exports